export default {
    formId: "PrevencionForm",
    formField: {
        //FIRST FORM
        nombre: {
            name: 'nombre',
            label: 'Nombre*',
            requiredErrorMsg: 'Por favor, ingrese su nombre'
        },
        apellido: {
            name: 'apellido',
            label: 'Apellido*',
            requiredErrorMsg: 'Por favor, ingrese su apellido'
        },
        email: {
            name: 'email',
            label: 'Email*',
            requiredErrorMsg: 'Por favor, ingrese su email'
        },
        telefono: {
            name: 'telefono',
            label: 'Celular*',
            requiredErrorMsg: 'Por favor, ingrese su celular'
        },
        codigosLocalidad: {
            name: 'codigosLocalidad',
            label: 'Ubicación del riesgo (Cód. Postal)',
            requiredErrorMsg: 'Debe completar este campo'
        },
        dni: {
            name: 'dni',
            label: 'DNI*',
            requiredErrorMsg: 'Por favor, ingrese su número de documento',
            invalidErrorMsg: 'DNI inválido'
        },
        fechaNacimiento: {
            name: 'fechaNacimiento',
            label: 'Fecha de nacimiento *',
            requiredErrorMsg: 'Debe especificar la fecha de nacimiento'
        },
        cargaFamilia: {
            name: 'cargaFamilia',
            label: 'Carga de familia *',
            requiredErrorMsg: 'Debe especificar la carga de familia'
        },
        numeroHijos: {
            name: 'numeroHijos',
            label: 'Cantidad de hijos *',
            requiredErrorMsg: 'Debe especificar la cantidad de hijos'
        },
        //SECOND FORM
        condicionLaboral: {
            name: 'condicionLaboral',
            label: 'Condición laboral *',
            requiredErrorMsg: 'Debe especificar la condición laboral'
        },
        montoBruto: {
            name: 'montoBruto',
            label: 'Monto bruto *',
            requiredErrorMsg: 'Debe especificar su monto bruto'
        },
    },
};
